module.exports = __webpack_public_path__ + "img/post_img_12-320x202.41d8d025.jpg";